<template>
  <div class="fou--rootDiv">
    <div v-if="isBannerOnPage">
      <FouWarningBannerOnPage 
        @openEmailVerificationModal="openEmailVerificationModal"
      />
    </div>
    <!-- Grace period expired banner: always show when expired (even if emailVerified is false/true). -->
    <div v-else-if="gracePeriodExpired">
      <FouWarningBanner
        :showCloseIcon="false"
        :labelKey="labelKey"
        :showVerifyButton="showVerifyButton"
        @openEmailVerificationModal="openEmailVerificationModal"
      />
    </div>
    <!-- Standard unverified banner: show when email is unverified (respect dismissable + dismissed state). -->
    <div v-else-if="!onlyGracePeriodExpired && (!dismissable || (!isEmailVerified && !bannerDismissed))">
      <FouWarningBanner
        :showCloseIcon="showCloseIcon"
        :labelKey="labelKey"
        :showVerifyButton="showVerifyButton"
        @openEmailVerificationModal="openEmailVerificationModal"
        @dismiss="dismissEmailVerifyBanner"
      />
    </div>

    <!-- Email Verification Modal -->
    <FouEmailSendModal
      :isOpen="isEmailVerificationOpen"
      @close="closeEmailVerificationModal"
    />
  </div>
</template>

<script src="./script.js"></script>
<style lang="scss" src="./stylesheet/index.scss" />
